const _excluded = ["rowId"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import { useLoaderData, useRevalidator } from 'react-router';

import { useSetAtom, useAtomValue } from 'jotai';
import { t, Translate } from "../../../../I18N";
import * as relationshipTypesAPI from "../../../api/relationshiptypes";

import { notificationAtom, templatesAtom, relationshipTypesAtom } from "../../../atoms";
import { Button, Table, Sidepanel, ConfirmationModal } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { columns } from "./components/TableComponents";
import { Form } from "./components/Form";

const relationshipTypesLoader =
(headers) =>
async () =>
(await relationshipTypesAPI.get(headers)).map((rel) => _objectSpread(_objectSpread({}, rel), {}, { rowId: rel._id }));

const RelationshipTypes = () => {
  const relationshipTypes = useLoaderData();
  const revalidator = useRevalidator();

  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);
  const setRelationshipTypes = useSetAtom(relationshipTypesAtom);
  const templates = useAtomValue(templatesAtom);




  const [formValues, setFormValues] = useState({});

  const [selectedItems, setSelectedItems] = useState([]);
  const [tableRelationshipTypes, setTableRelationshipTypes] = useState([]);

  useEffect(() => {
    setTableRelationshipTypes(
      relationshipTypes.
      map((relationshipType) => {
        const templatesUsingIt = templates.
        map((tmpl) => {var _tmpl$properties;
          const usingIt = (_tmpl$properties = tmpl.properties) === null || _tmpl$properties === void 0 ? void 0 : _tmpl$properties.some(
            (property) => property.relationType === relationshipType._id
          );
          return usingIt ? tmpl : null;
        }).
        filter((tmpl) => tmpl);

        return _objectSpread(_objectSpread({},
        relationshipType), {}, {
          rowId: relationshipType._id,
          translation: t(relationshipType._id, relationshipType.name, null, false),
          templates: templatesUsingIt,
          disableRowSelection: Boolean(templatesUsingIt.length) });

      }).
      sort((a, b) => a.translation.localeCompare(b.translation))
    );
  }, [relationshipTypes, templates]);

  useEffect(() => {
    setRelationshipTypes(relationshipTypes);
  }, [relationshipTypes, setRelationshipTypes]);

  const edit = (row) => {
    setFormValues(row.original);
    setIsSidepanelOpen(true);
  };

  const add = () => {
    setFormValues({ name: '', rowId: 'NEW_REL' });
    setIsSidepanelOpen(true);
  };

  const submit = async (submitedData) => {
    const { rowId } = submitedData,data = _objectWithoutProperties(submitedData, _excluded);
    try {
      await relationshipTypesAPI.save(data);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Updated")
      });
      setIsSidepanelOpen(false);
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: error.error
      });
      setIsSidepanelOpen(false);
    }
    await revalidator.revalidate();
  };

  const deleteSelected = async () => {
    try {
      await relationshipTypesAPI.deleteRelationtypes(selectedItems.map((item) => item._id));
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Updated")
      });
      setShowConfirmationModal(false);
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: error.error
      });
      setShowConfirmationModal(false);
    }
    await revalidator.revalidate();
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Relationship types" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      enableSelections: true,
      columns: columns({ edit }),
      data: tableRelationshipTypes,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Relationship types"

      ),

      onChange: ({ selectedRows }) => {
        setSelectedItems(
          tableRelationshipTypes.filter((relationship) => relationship.rowId in selectedRows)
        );
      } }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: selectedItems.length ? 'bg-primary-50' : '' }, void 0,
    selectedItems.length > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: () => setShowConfirmationModal(true),
      color: "error",
      "data-testid": "relationship-types-delete" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedItems.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"),
    relationshipTypes.length
    ),

    selectedItems.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: add, "data-testid": "relationship-types-add" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add relationship type")
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      title: /*#__PURE__*/
      _jsx(Translate, { className: "uppercase" }, void 0,
      `${(formValues === null || formValues === void 0 ? void 0 : formValues.name) === '' ? 'Add' : 'Edit'} relationship type`
      ),

      isOpen: isSidepanelOpen,
      closeSidepanelFunction: () => setIsSidepanelOpen(false),
      size: "medium",
      withOverlay: true }, void 0, /*#__PURE__*/

    _jsx(Form, {
      relationtype: formValues,
      closePanel: () => setIsSidepanelOpen(false),
      currentTypes: relationshipTypes,
      submit: submit }
    )
    ),
    showConfirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      size: "lg",
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Do you want to delete the following items?"),
      body: /*#__PURE__*/
      _jsx("ul", { className: "flex flex-wrap max-w-md gap-8 list-disc list-inside" }, void 0,
      selectedItems.map((item) => /*#__PURE__*/
      _jsx("li", {}, item.name, item.name)
      )
      ),

      onAcceptClick: deleteSelected,
      onCancelClick: () => setShowConfirmationModal(false),
      dangerStyle: true }
    )

    ));

};

export { RelationshipTypes, relationshipTypesLoader };